export default __webpack_public_path__ + "static/media/icon-artefact-3d.cfbda64c.svg";